<div class="row">
    <nav class="navbar navbar-fixed-top {{app.environment === 'dev' ? ' environment-dev' : app.environment === 'local' ? 'environment-local' : app.environment === 'staging' ? 'environment-staging' : ''}}" role="navigation" style="margin-bottom: 0">
        <div class="navbar-header">
            <div class="page-title" (click)="toggleNavigation()">
                <h1>{{ app.appInfo.title }}</h1>
            </div>
            <!-- Replaced by app-update-banner, which detects new deploys from the loaded bundle.
            <div class="navbar-warning" *ngIf="app.appInfo.versionWarning">
                <i class="fa fa-warning ms-2" style="color: rgb(182, 0, 0)" title="{{app.appInfo.versionWarning}}"></i>
            </div> -->
        </div>
        <ul class="nav navbar-top-links navbar-right d-none d-sm-block">
            <li style="margin: 5px; margin-right: 15px">
                <a [routerLink]="''" style="padding: 0"> <img src="./assets/images/logo.png" style="width: 100%" /> </a>
            </li>
        </ul>
    </nav>
</div>
